import React, { useState, useEffect, useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Checkbox, IconButton, TextField, CircularProgress, Box, Typography, Tooltip, FormControl, RadioGroup, Radio, FormControlLabel, Button, Stack, Autocomplete, TableContainer, TableHead, TableRow, TableCell, TableBody, Table, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Switch, } from "@mui/material";
import CommentIcon from '@mui/icons-material/Comment';
import { Colors } from "../../../Styles/Colors";
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { ImagePaths } from "../../../Utility/ImagePaths";
import { AmountFormat, ContentInTooltip, formatDate, formatDateAndTime, GetStoreBaseUrl } from "../../../Components/CommonFunctions/CommonFunctions";
import { CurrencySymbol } from "../../../Utility/Constants";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import Loader from "../../../Components/Loader";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { ReasonPopup } from "../../../Components/Common Components/CommonComponents";
import { DateTime } from "luxon";
import { localGetItem } from "../../../Utility/Services/CacheProviderService";
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";

function StoreAuditAdd(props) {
    const { loggedData } = props;
    const history = useHistory();
    const location = useLocation();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [stockList, setStockList] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [forApprove, setForApprove] = useState((loggedData?.module_name === "store_module" && location.states?.audit_data?.status === "Completed" && location.states?.edit_audit) || (location?.states?.view_audit && (location.states?.audit_data?.status === "Approved" || location.states?.audit_data?.status === "Rejected")));
    const [forEdit, setForEdit] = useState(location.states?.edit_audit || false);
    const [auditData, setAuditData] = useState(location.states?.audit_data || null);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [rejectReasonPop, setRejectReasonPop] = useState(false);
    const [showmismatch, setShowMismatch] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [searchText, setSearchText] = useState('');
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedRowindex, setSelectedRowindex] = useState(null);
    const [Details, setDetails] = useState({
        audit_id: null,
        audit_created_by: null,
        audit_location_id: null,
        audit_location: null,
        audit_date: null,
    })

    const inputRefs = useRef({});

    const handleInputChange = (id, value) => {
        if (value === "" || (CommonValidation.numberOnly(value) && value?.length <= 5)) {
            let ItemIndex = stockList?.findIndex((list)=>(list?.id === id))
            inputRefs.current[ItemIndex] = value;
            setStockList((prev) =>
                prev.map((row, rowIndex) =>
                    rowIndex === ItemIndex
                        ? { ...row, audit_value: inputRefs.current[ItemIndex] || "" }
                        : row
                )
            );
        }

    };

    const handleBlur = (index) => {
        setStockList((prev) =>
            prev.map((row, rowIndex) =>
                rowIndex === index
                    ? { ...row, audit_value: inputRefs.current[index] || "" }
                    : row
            )
        );
    };

    useEffect(() => {
        setDetails({
            ...Details,
            audit_id: location.states?.audit_data?.audit_code ? location.states?.audit_data?.audit_code : "-",
            audit_created_by: location.states?.audit_data?.created_by ? location.states?.audit_data?.created_by : localGetItem("LogedUserName") ? localGetItem("LogedUserName") : "-",
            audit_location: location.states?.audit_data?.sub_location_name || location.states?.audit_data?.store_name || (loggedData?.module_name === "store_module" ? loggedData?.store_name : loggedData?.sublocation_name),
            audit_location_id: loggedData?.sublocation_id,
            audit_date: new Date(Date.now()).toISOString().slice(0, 19)
        })
        getStockList()
    }, [])

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const popupClose = () => {
        setRejectReasonPop(false)
    }

    const reasonadd = (reason) => {
        setRejectReasonPop(false)
        PutAuditData("Rejected", reason)
    }

    const errorMessage = (msg) => {
        setisloader(false)
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setisloader(false)
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getStockList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_AUDIT_STOCK + "?sub_location_id=" + (loggedData?.module_name === "store_module" ? "" : loggedData?.sublocation_id) + (location?.states?.audit_data ? `&audit_id=${location?.states?.audit_data?.id}` : ""))
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        if (location?.states?.view_audit) {
                            let AuditData = []
                            response.data.data?.forEach((list) => {
                                AuditData.push({
                                    ...list,
                                    stock_in_quantity: (location.states?.audit_data?.status === "Approved" ? list?.current_stock_in_quantity : list?.stock_in_quantity)
                                })
                            })
                            setStockList(AuditData)
                        } else {
                            let AuditData = response.data.data || []
                            setStockList(AuditData)
                        }
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const tableView = () => {
        try {
            let filtereddata = stockList?.filter((data) => {
                return (
                    (data?.product_name === null ? null : data?.product_name?.toLowerCase()?.includes(searchText?.toLowerCase())) ||
                    (data?.product_code === null ? null : data?.product_code?.toLowerCase()?.includes(searchText?.toLowerCase())) ||
                    (data?.department_name === null ? null : data?.department_name?.toLowerCase()?.includes(searchText?.toLowerCase())) ||
                    (data?.batch_no === null ? null : data?.batch_no?.toLowerCase()?.includes(searchText?.toLowerCase()))
                );
            });
            if (showmismatch && forApprove) {
                filtereddata = filtereddata?.filter((item) => ((+item?.stock_in_quantity || 0) - (+item?.audit_value || 0) !== 0))
            }
            return (
                <TableContainer sx={{ height: '60vh', width: '100%', marginTop: "0.5vw", backgroundColor: Colors.white }}>
                    <Table stickyHeader aria-label="sticky table" size="small" >
                        <TableHead sx={{ backgroundColor: Colors.Background }}>
                            <TableRow>
                                <TableCell className='billing_tbl_head'>Product Code</TableCell>
                                <TableCell className='billing_tbl_head'>Department</TableCell>
                                <TableCell className='billing_tbl_head'>Product Name</TableCell>
                                <TableCell className='billing_tbl_head'>Batch No</TableCell>
                                <TableCell className='billing_tbl_head'>Product Type</TableCell>
                                <TableCell className='billing_tbl_head'>Category</TableCell>
                                <TableCell className='billing_tbl_head'>Expiry</TableCell>
                                <TableCell className='billing_tbl_head'>{forApprove ? "Audit Value" : "Quantity"}</TableCell>
                                {forApprove ? <TableCell className='billing_tbl_head'>Stock</TableCell> : null}
                                {forApprove ? <TableCell className='billing_tbl_head'>Mismatch</TableCell> : null}
                                {forApprove ? <TableCell className='billing_tbl_head'>Action</TableCell> : null}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filtereddata?.map((item, index) => {
                                let TextColor = ((+item?.stock_in_quantity || 0) - (+item?.audit_value || 0) !== 0 && forApprove && (item?.audit_value !== "" && item?.audit_value !== null)) ? Colors.red : Colors.black
                                let isMismatch = ((+item?.stock_in_quantity || 0) - (+item?.audit_value || 0) !== 0 && forApprove && (item?.audit_value !== "" && item?.audit_value !== null)) ? true : false
                                return (
                                    <TableRow key={index} sx={{ height: "5dvh"}}>
                                        <TableCell className='billing_tbl_body'>
                                            {ContentInTooltip((item?.product_code || "-"), 30, '0.75rem', 500, 0, TextColor)}
                                        </TableCell>
                                        <TableCell className='billing_tbl_body'>
                                            {ContentInTooltip((item?.department_name || "-"), 30, '0.75rem', 500, 0, TextColor)}
                                        </TableCell>
                                        <TableCell className='billing_tbl_body'>
                                            {ContentInTooltip((item?.product_name || "-"), 30, '0.9rem', 600, 0, TextColor)}
                                        </TableCell>
                                        <TableCell className='billing_tbl_body'>
                                            {ContentInTooltip((item?.batch_no || "-"), 30, '0.9rem', 500, 0, TextColor)}
                                        </TableCell>
                                        <TableCell className='billing_tbl_body'>
                                            {ContentInTooltip((item?.product_type_name || "-"), 30, '0.75rem', 500, 0, TextColor)}
                                        </TableCell>
                                        <TableCell className='billing_tbl_body'>
                                            {ContentInTooltip((item?.category_name || "-"), 30, '0.75rem', 500, 0, TextColor)}
                                            {ContentInTooltip((item?.sub_category_name || "-"), 30, '0.75rem', 500, 0, TextColor)}
                                        </TableCell>
                                        <TableCell className='billing_tbl_body'>
                                            {ContentInTooltip((item?.expiry_date ? formatDate(item?.expiry_date, true) : "-"), 30, '0.75rem', 500, 0, TextColor)}
                                        </TableCell>
                                        <TableCell>
                                            <Box component={'div'}>
                                                <TextField
                                                    inputProps={{ style: { height: '4vh', padding: '0 14px', width: "5dvw" }, maxLength: 7 }}
                                                    autoComplete='off'
                                                    disabled={location?.states?.view_audit}
                                                    size="small"
                                                    value={item?.audit_value === 0 ? "0" : (item?.audit_value || "")}
                                                    onChange={(e) => handleInputChange(item?.id, e.target.value)}
                                                // onBlur={() => handleBlur(index)}
                                                />
                                            </Box>
                                        </TableCell>
                                        {forApprove ? <TableCell className='billing_tbl_body'>
                                            {ContentInTooltip((item?.stock_in_quantity || "-"), 30, '0.9rem', 500, 0, TextColor)}
                                        </TableCell> : null}
                                        {forApprove ? <TableCell className='billing_tbl_body'>
                                            {ContentInTooltip((item?.audit_value !== "" && item?.audit_value !== null) ? ((+item?.stock_in_quantity || 0) - (+item?.audit_value || 0)) : "-", 30, '0.9rem', 500, 0, TextColor)}
                                        </TableCell> : null}
                                        {forApprove ? <TableCell className='billing_tbl_body'>
                                            <Box component={'div'} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <Tooltip title={(item?.comments && isMismatch) ? item?.comments : ""} arrow placement="top">
                                                    <IconButton disabled={!isMismatch} size="small" onClick={() => {
                                                        setSelectedRow(item)
                                                        setSelectedRowindex(item?.id)
                                                    }}><CommentIcon color={isMismatch ? (item?.comments ? "primary" : "error") : "grey"} /></IconButton>
                                                </Tooltip>
                                            </Box>
                                        </TableCell> : null}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            )
        } catch (e) {

        }
    }

    const renderReasonpop = () => {
        return (
            <Dialog open={true} >
                <DialogTitle id="eMed_MaxDialog_Title">{"Mismatch reason"}</DialogTitle>
                <DialogContent sx={{ padding: "2dvw", width: '29dvw', display: 'flex', alignItems: 'center', justifyContent: "center", flexDirection: 'column' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between", width: '25dvw', marginBottom: "0.5vw" }}>
                        <Box>
                            <Typography fontSize={'.8vw'} color={'#888888'}>{`Product Name`}</Typography>
                            {ContentInTooltip(selectedRow?.product_name, 30, '0.8vw', 600)}
                        </Box>
                        <Box>
                            <Typography fontSize={'.8vw'} color={'#888888'}>{`Batch No`}</Typography>
                            {ContentInTooltip(selectedRow?.batch_no, 30, '0.8vw', 500)}
                        </Box>
                        <Box>
                            <Typography fontSize={'.8vw'} color={'#888888'}>{`Department`}</Typography>
                            {ContentInTooltip(selectedRow?.department_name, 30, '0.8vw', 500)}
                        </Box>
                    </Box>
                    <Divider textAlign='left'>
                        <Typography component={'p'} sx={{ marginY: "0.5vw" }} className='eMed_Service_title'>Reason *</Typography>
                    </Divider>
                    <FormControl sx={{ marginLeft: "1.5vw", display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: "0.5vw" }}>
                        <RadioGroup
                            value={selectedRow?.reason ? selectedRow?.reason : ""}
                            name="radio-buttons-group"
                            sx={{ display: 'flex', flexDirection: 'row', marginLeft: '1vw' }}
                            onChange={(e) => {
                                setSelectedRow((prev) => ({ ...prev, "reason": e.target.value }));
                            }}
                            emed_tid='active_inactive_filter'
                        >
                            <FormControlLabel value={1} control={<Radio disabled={location?.states?.view_audit} size="small" emed_tid="esc_Breakage" />} label={'Breakage'} />
                            <FormControlLabel value={2} control={<Radio disabled={location?.states?.view_audit} size="small" emed_tid="esc_Loss" />} label={'Loss'} />
                            <FormControlLabel value={3} control={<Radio disabled={location?.states?.view_audit} size="small" emed_tid="esc_Expired" />} label={'Expired'} />
                            <FormControlLabel value={4} control={<Radio disabled={location?.states?.view_audit} size="small" emed_tid="esc_Miscellaneous" />} label={'Miscellaneous'} />
                            <FormControlLabel value={5} control={<Radio disabled={location?.states?.view_audit} size="small" emed_tid="esc_Others" />} label={'Others'} />
                        </RadioGroup>
                    </FormControl>
                    <Box component={'div'}>
                        <TextField
                            multiline={true}
                            rows={3}
                            inputProps={{ maxLength: 250 }}
                            disabled={location?.states?.view_audit}
                            sx={{ width: '25dvw', marginTop: '1vw' }}
                            autoComplete='off'
                            size="small"
                            label={"Mismatch comments *"}
                            value={selectedRow?.comments || ""}
                            onChange={(e) => { setSelectedRow((prev) => ({ ...prev, "comments": e.target.value })) }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' size='small' className='eMed_Filter_Btns' onClick={() => {
                        setSelectedRow(null)
                        setSelectedRowindex(null)
                    }}>{"Close"}</Button>
                    <Button variant='contained' size='small' className='eMed_Filter_Btns'
                        disabled={!selectedRow?.reason || !selectedRow?.comments || location?.states?.view_audit}
                        onClick={() => {
                            setStockList((prev) =>
                                prev.map((row, rowIndex) =>
                                    row?.id === selectedRowindex
                                        ? selectedRow
                                        : row
                                )
                            );
                            setSelectedRowindex(null)
                            setSelectedRow(null)
                        }}>{"Ok"}</Button>
                </DialogActions>
            </Dialog>
        )
    }

    const CheckValidstock = () => {
        let Flag = true
        for (let i = 0; i < stockList?.length; i++) {
            if (stockList[i]?.audit_value && (((+stockList[i]?.stock_in_quantity || 0) - (+stockList[i]?.audit_value || 0)) !== 0) && (!stockList[i]?.comments || !stockList[i]?.reason)) {
                errorMessage(`Enter the reason for mismatch for ${stockList[i]?.product_name} - ${stockList[i]?.batch_no}`)
                Flag = false
                break
            }
        }
        return Flag
    }
    const PostAuditData = (status = null) => {
        try {
            setisloader(true)
            let LineItems = []
            stockList?.forEach((list) => {
                LineItems.push({
                    'id': auditData ? list?.id : null,
                    'audit_value': +list?.audit_value === 0 ? 0 : (+list?.audit_value || null),
                    'stock_id': list?.stock_id || null,
                })
            })

            let startDate = new Date()
            let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
            let Aptime = DateTime.fromJSDate(startDate).toLocaleString(DateTime.TIME_24_SIMPLE);
            const invoice_date = date ? `${DateTime.fromJSDate(startDate).toFormat("yyyy-MM-dd")} ${Aptime}:00` : ""
            let data = {
                'id': auditData ? auditData?.id : null,
                'sub_location_id': Details?.audit_location_id || null,
                'audit_date': invoice_date || "",
                'audit_status': status ? status : 'Inaudit',
                'audit_lines': LineItems
            }

            RestAPIService.create(data, Serviceurls.STORE_AUDIT_STOCK)
                .then((response) => {
                    if (response.data.status === 'success') {
                        history.push({ pathname: (loggedData?.module_name === "store_module" ? `/StorePurchase/Audit` : `${GetStoreBaseUrl()}/Audit`), states: { success_message: response.data.message } })
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }
    const PutAuditData = (status = null, reason = "") => {
        try {
            setisloader(true)
            let LineItems = []
            stockList?.forEach((list) => {
                LineItems.push({
                    'id': auditData ? list?.id : '',
                    'audit_value': list?.audit_value == "0" ? 0 : (+list?.audit_value || null),
                    'stock_id': (list?.sublocation_stock_list_id || null),
                    'mismatched_quantity': ((+list?.stock_in_quantity || 0) - (+list?.audit_value || 0)),
                    'current_stock_in_quantity': (+list?.stock_in_quantity) || 0,
                    'reason': (list?.reason) || null,
                    'comments': (list?.comments) || "",
                })
            })

            let data = {
                'audit_id': auditData ? auditData?.id : null,
                'audit_status': status,
            }
            if (reason) {
                data['rejection_comments'] = reason
            } else {
                data['audit_lines'] = LineItems
            }

            RestAPIService.updateWithOutId(data, Serviceurls.STORE_AUDIT_STOCK)
                .then((response) => {
                    if (response.data.status === 'success') {
                        history.push({ pathname: (loggedData?.module_name === "store_module" ? `/StorePurchase/Audit` : `${GetStoreBaseUrl()}/Audit`), states: { success_message: response.data.message } })
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    return (
        <Box>
            <Box component={'div'} className='eMed_Pharma_Header_Card' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1vw' }}>
                <Stack direction="row" spacing={1} alignItems="center"><IconButton size="small" onClick={() => {
                    history.push({ pathname: (loggedData?.module_name === "store_module" ? `/StorePurchase/Audit` : `${GetStoreBaseUrl()}/Audit`) })
                }} ><img className="emedhub_popupIcon_img" src={ImagePaths.LabBackButton.default} alt={"Back"} /></IconButton><Typography sx={{ color: "#616161" }}> {"Back to Audit"}</Typography></Stack>
                <Box display={'flex'} flexDirection={'row'} width={'34vw'} justifyContent={'space-evenly'} padding={'1vw'} visibility={location?.states?.view_audit ? "hidden" : "visible"}>
                    {forApprove ? <Button size={'small'} color="error" variant="contained" sx={{ textTransform: 'capitalize', width: '10vw' }} onClick={() => {
                        setRejectReasonPop(true)
                    }}>Reject Audit</Button> : null}
                    {forApprove ? <Button size={'small'} variant="contained" sx={{ textTransform: 'capitalize', width: '10vw' }} onClick={() => {
                        let Flag = true
                        for (let i = 0; i < stockList.length; i++) {
                            if (stockList[i]?.audit_value === "" || stockList[i]?.audit_value === null || stockList[i]?.audit_value === undefined) {
                                errorMessage(`Enter audit value for ${stockList[i]?.product_name} ( Batch - ${stockList[i]?.batch_no} )`)
                                Flag = false
                                break
                            }
                        }
                        if (Flag) {
                            if (CheckValidstock()) {
                                PutAuditData("Approved")
                            }
                        }
                    }}>Approve Audit</Button> : null}
                    {forApprove ? null : <Button size={'small'} variant="outlined" sx={{ textTransform: 'capitalize', width: '10vw' }} onClick={() => {
                        PostAuditData("Inaudit")
                    }}>Save Audit</Button>
                    }
                    {forApprove ? null : <Button size={'small'} variant="contained" sx={{ textTransform: 'capitalize', width: '10vw' }} onClick={() => {
                        let Flag = true
                        for (let i = 0; i < stockList.length; i++) {
                            if (stockList[i]?.audit_value === "" || stockList[i]?.audit_value === null || stockList[i]?.audit_value === undefined) {
                                errorMessage(`Enter audit value for ${stockList[i]?.product_name} ( Batch - ${stockList[i]?.batch_no} )`)
                                Flag = false
                                break
                            }
                        }
                        if (Flag) {
                            PostAuditData("Completed")
                        }
                    }}>Complete Audit</Button>}
                </Box>
            </Box>
            <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
                <Box display={'flex'} flexDirection={'row'} alignItems={'center'} height={'13vh'} justifyContent={'space-between'}>
                    <Box display={'flex'} flexDirection={'column'} backgroundColor={'white'} height={'13vh'} width={'93vw'}>
                        <Box>
                            <Typography marginLeft={'1vw'} fontSize={'1vw'}>Audit Details</Typography>
                        </Box>
                        <Box borderBottom={'1px solid #888888'}></Box>
                        <Box display={'flex'} flexDirection={'row'} padding={'1vw'} justifyContent={"space-between"} width={'93vw'} alignItems={"center"}>
                            <Box width={'29vw'}>
                                <Typography fontSize={'.8vw'} color={'#888888'}>{`Audit ID`}</Typography>
                                {ContentInTooltip(Details?.audit_id, 30, '1vw', 600)}
                            </Box>
                            <Box width={'29vw'}>
                                <Typography fontSize={'.8vw'} color={'#888888'}>{`Audit Created By`}</Typography>
                                {ContentInTooltip(Details?.audit_created_by, 30, '1vw', 600)}
                            </Box>
                            <Box width={'29vw'}>
                                <Typography fontSize={'.8vw'} color={'#888888'}>{`Audit Location`}</Typography>
                                {ContentInTooltip(Details?.audit_location, 30, '1vw', 600)}
                            </Box>
                            <Box width={'29vw'} sx={{ visibility: forApprove ? "visible" : "hidden" }}>
                                <FormControlLabel control={<Switch size='small' checked={showmismatch} onChange={(e) => {
                                    setShowMismatch(e.target.checked)
                                }} />} label="Show Mismatch Only" />
                            </Box>
                            <Box width={'29vw'} sx={{ visibility: forApprove ? "visible" : "hidden" }}>
                                <TextField
                                    label={"Search"}
                                    size="small"
                                    value={searchText}
                                    onChange={(e) => {
                                        setSearchText(e.target.value)
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>

                </Box>
                <Box>
                    {tableView()}
                </Box>
            </Box>
            {console.log("stockList", stockList)}
            {selectedRow !== null && selectedRowindex !== null ? renderReasonpop() : null}
            {isloader ? <Loader loaderOpen={isloader} /> : null}
            {
                (errorMsg && errorMsgText) ?
                    <ToastMsg
                        severity={'error'}
                        msg={errorMsgText}
                        msgPop={msgClose.bind(this)}
                    />
                    : null
            }
            {
                (successMsg && successMsgText) ?
                    <ToastMsg
                        severity={'success'}
                        msg={successMsgText}
                        msgPop={msgClose.bind(this)}
                    />
                    : null
            }
            {
                rejectReasonPop ? <ReasonPopup
                    title={"Rejection Remarks"}
                    AlertPopupClose={popupClose.bind(this)}
                    label={'Enter reject remarks here'}
                    btntext={'close'}
                    btnvarient={'outlined'}
                    btntext1={'Reject Audit'}
                    btnvarient1={'contained'}
                    btncolor={'error'}
                    sendCmt={reasonadd.bind(this)}
                /> : null
            }
        </Box >

    );
};

export default StoreAuditAdd;
